// A Bizonylatok kereső kliens-oldali segédei (2026-09-28).
//
// ⚠ MIÉRT: a javaslat-lista korábban a BETÖLTÖTT oldal (első 100 sor) bizonylataiból
// épült, a szerver-keresés csak Enterre indult. Élő mérés (2. cég): az „MBH Bank Nyrt."
// (#1626) az alapnézet 213. sora volt, így a „MBH" gépelésére a javaslat csak a
// „Digital Charging Solutions GmbH"-t mutatta — a bizonylat „nem volt meg", pedig a
// szerver megtalálta volna. Most a gépelés (késleltetve) a SZERVER-keresést indítja, és
// javaslat csak a már erre a szövegre kapott eredményből készül.

// `#1626`, `# 1626`, `#01626` → 1626; bármi más → null. A szerver ugyanezt érti
// (`backend/app/api/documents.py` `_DOC_ID_RE`), itt csak a panel-megnyitáshoz kell.
export function parseDocIdQuery(input) {
  const m = /^\s*#\s*(\d+)\s*$/.exec(input || '');
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return Number.isSafeInteger(n) && n > 0 && n <= 2147483647 ? n : null;
}

// Mikor induljon a szerver-keresés gépelés közben: legalább 2 karakter, vagy egy
// teljes `#szám` (a `#5` is értelmes azonosító).
export function isLiveSearchable(input) {
  const s = (input || '').trim();
  return s.length >= 2 || parseDocIdQuery(s) !== null;
}

export const SEARCH_DEBOUNCE_MS = 350;
